import * as Yup from 'yup';
import { CHAINS } from '../constants/chains';

export const createNetworkSchema = Yup.object().shape({
  name: Yup.string().required(),
  confirmations: Yup.number().required(),
  chain: Yup.number().max(CHAINS.length).required(),
});
